import { render, staticRenderFns } from "./Game5-8.vue?vue&type=template&id=fdba6f1e&scoped=true&"
import script from "./Game5-8.vue?vue&type=script&lang=js&"
export * from "./Game5-8.vue?vue&type=script&lang=js&"
import style0 from "./Game5-8.vue?vue&type=style&index=0&id=fdba6f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdba6f1e",
  null
  
)

export default component.exports